import React, { useContext, useState, useEffect } from "react";
import AuthContext from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = "https://api.nwayami.com/api";

const MinhaContaPage = () => {
  const { user, logoutUser } = useContext(AuthContext);
  const [enderecos, setEnderecos] = useState([]);
  const [newEndereco, setNewEndereco] = useState({
    rua: "",
    provincia: "",
    cidade: "",
    pais: "",
    codigo_postal: "" // Adicionando o campo código postal
  });
  const navigate = useNavigate();

  // Verifica se o usuário não está logado e redireciona
  useEffect(() => {
    if (!user) {
      navigate("/loginpage"); // Redireciona se não estiver logado
    } else {
      // Função para buscar os endereços do usuário
      const fetchEnderecos = async () => {
        const token = localStorage.getItem("authToken");
        if (!token) {
          // Se o token não estiver presente, redireciona para login
          navigate("/loginpage");
          return;
        }

        try {
          const response = await axios.get(`${API_URL}/enderecos/`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setEnderecos(response.data);  // Atualiza os endereços com os dados recebidos
        } catch (error) {
          console.error("Erro ao carregar os endereços:", error);
        }
      };

      fetchEnderecos(); // Chama a função quando o componente é montado e o usuário está autenticado
    }
  }, [user, navigate]);

  // Função para adicionar um novo endereço
  const addEndereco = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/loginpage");
      return;
    }

    try {
      const response = await axios.post(
        `${API_URL}/enderecos/`,
        {
          ...newEndereco,
          usuario: user.id,  // Incluindo o ID do usuário no envio
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEnderecos((prevEnderecos) => [...prevEnderecos, response.data]);  // Adiciona o novo endereço à lista
      setNewEndereco({ rua: "", provincia: "", cidade: "", pais: "", codigo_postal: "" }); // Limpa os campos do novo endereço
    } catch (error) {
      console.error("Erro ao adicionar o endereço:", error);
    }
  };

  // Função para remover um endereço
  const removeEndereco = async (id) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.error("Token não encontrado. Redirecionando para login...");
      navigate("/loginpage");
      return;
    }

    try {
      await axios.delete(`${API_URL}/enderecos/${id}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setEnderecos((prevEnderecos) => prevEnderecos.filter(endereco => endereco.id !== id)); // Remove o endereço da lista local
    } catch (error) {
      console.error("Erro ao remover o endereço:", error);
    }
  };

  // Verifica se o 'user' está disponível antes de renderizar o conteúdo
  if (!user) {
    return null; // Ou exibe uma tela de carregamento/erro, caso prefira
  }

  return (
    <div className="container mt-5">
      <h2 style={{ marginTop: "80px" }}>Minha Conta</h2>
      <p><strong>Nome:</strong> {user.username}</p>
      <p><strong>Email:</strong> {user.email}</p>
      <p><strong>Telefone:</strong> {user.telefone}</p>

      {/* Exibir endereços */}
      <h3>Meus Endereços</h3>
      {enderecos.length > 0 ? (
        <ul>
          {enderecos.map(endereco => (
            <li key={endereco.id}>
              Rua: {endereco.rua}, Provincia: {endereco.provincia}, Cidade: {endereco.cidade}, País: {endereco.pais}
              <button
                className="btn btn-danger ml-2"
                onClick={() => removeEndereco(endereco.id)}
              >
                Remover
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p>Você não tem endereços cadastrados.</p>
      )}

      {/* Formulário para adicionar novo endereço */}
      <h3>Adicionar Novo Endereço</h3>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          addEndereco();
        }}
      >
        <input
          type="text"
          className="form-control"
          placeholder="Rua"
          value={newEndereco.rua}
          onChange={(e) => setNewEndereco({ ...newEndereco, rua: e.target.value })}
        />
        <input
          type="text"
          className="form-control"
          placeholder="Provincia"
          value={newEndereco.provincia}
          onChange={(e) => setNewEndereco({ ...newEndereco, provincia: e.target.value })}
        />
        <input
          type="text"
          className="form-control"
          placeholder="Cidade"
          value={newEndereco.cidade}
          onChange={(e) => setNewEndereco({ ...newEndereco, cidade: e.target.value })}
        />
        <input
          type="text"
          className="form-control"
          placeholder="País"
          value={newEndereco.pais}
          onChange={(e) => setNewEndereco({ ...newEndereco, pais: e.target.value })}
        />
        <input
          type="text"
          className="form-control"
          placeholder="Código Postal"
          value={newEndereco.codigo_postal}
          onChange={(e) => setNewEndereco({ ...newEndereco, codigo_postal: e.target.value })}
        />
        <button type="submit" className="btn btn-primary mt-2">
          Adicionar Endereço
        </button>
      </form>

      <button className="btn btn-danger mt-3" onClick={logoutUser}>
        Sair da conta
      </button>
    </div>
  );
};

export default MinhaContaPage;
